import React, { Component } from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { List, Map } from 'immutable'
import _isNil from 'lodash/isNil'
import _get from 'lodash/get'
import { getBoundActions } from '../../actions/index'
import { getSeo } from '../../services/url/index'
import { get as getConfig } from '../../config/index'
import Button, { TYPES } from '../Button/index'
import { connect as connectStaticText } from '../StaticText/connect'
import DropInVideoPlayer, { BASIC_CONTROLS, BASIC_CONTROL_OPTIONS_VOLUME, BASIC_CONTROL_OPTIONS_VOLUME_LABEL } from '../DropInVideoPlayer/index'
import HeroImage from '../HeroImage/index'
import {
  H1,
  H2,
  H3,
  H4,
} from '../Heading/index'
import { HEADING_TYPES } from '../Heading/_Heading'
import { TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM, TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN } from '../../services/dialog/index'
import { createPlayerSrc } from '../../services/brightcove/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { PLAN_SKU_INCREASED_PRICE_GAIA_PLUS, PLAN_CATEGORY_AI_ONLY } from '../../services/plans/index'
import { SCREEN_TYPE_EVENTS_PLUS } from '../../services/upstream-context/index'
import { getPmScreenSectionSectionIds } from '../../services/pm-screen/index'
import { getPmSectionDisplayMode, TYPE_CONTENT_LIST } from '../../services/pm-section/index'
import { createTitleGroupId } from '../../services/content/index'
import FaqsList from '../FaqsList/index'
import GridWithBackground from '../GridWithBackground/index'
import { URL_ARCHIVED_WORKSHOPS, URL_GO_PAGE } from '../../services/url/constants'
import IconV2, { ICON_TYPES, ICON_STYLES } from '../Icon.v2/index'
import {
  LIVE_ACCESS_SUBSCRIPTION_CODE,
  UPGRADE_NOW_URL,
  JOIN_NOW_URL,
  JOIN_NOW_QUERY,
} from '../../services/live-access-events/constants'
import { getSafeNodeId } from '../../services/node/index'
import { isPrimaryAccountProfile, userShouldReactivate } from '../../services/user-account/index'
import SectionTilesList from '../SectionTilesList/index'

import { EN } from '../../services/languages/constants'
import { getPrimary } from '../../services/languages/index'
import { TILE_VERTICAL } from '../Tile.v2/constants'
import { useGetPlanDataBySku } from '../../services/plans/hooks'
import Experience from './Experience'
import EventList from './EventList'
import DISPLAY_MODES from './constants'

const bannerMediaIdByLanguage = {
  en: 6031111169001,
  es: 6078102783001,
  de: 6031111169001,
  fr: 6031111169001,
}
const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

function componentFromHTML (html) {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

function onClickAccountChangePlan (sku, props, plansList, currentPlan) {
  const { setPlanChangeSelected, renderModal } = props
  const graphQLPlansList = List.isList(plansList) ? plansList : List()
  const selectedPlan = planGraphQLActive ? graphQLPlansList.find((p) => p.get('sku') === sku) : sku
  setPlanChangeSelected(selectedPlan)
  renderModal(TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM, {
    hideDismiss: false,
    ...(planGraphQLActive && { currentPlan }),
  })
}

function onClickChildProfileChangePlan (props) {
  const { renderModal } = props
  renderModal(TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN, {
    hideDismiss: false,
  })
}

function TopSectionBanner (props) {
  const {
    user,
    plans,
    auth,
    language,
    staticText,
    userAccount,
  } = props
  const authJwt = auth.get('jwt')
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const isAccountOwner = isPrimaryAccountProfile(props)
  const gqlPlanData = useGetPlanDataBySku({
    userLanguage,
    authJwt,
    planSkus: PLAN_SKU_INCREASED_PRICE_GAIA_PLUS,
  }) || Map()
  let plansData = plans.getIn(['data', 'plans'])
  const userPlanSku = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planSku'])
  const gqlUserPlanData = useGetPlanDataBySku({
    userLanguage: language,
    authJwt: auth.get('jwt'),
    planSkus: userPlanSku,
    forceRefresh: true,
  }) || Map()
  const userPlanComplete = gqlUserPlanData.get('complete', false)
  const userPlanData = gqlUserPlanData.get('plans', List()) || List()
  const currentPlan = userPlanData.get(0) || Map()
  const userPlanCategory = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planCategory'])
  const isAiOnly = userPlanCategory === PLAN_CATEGORY_AI_ONLY

  if (planGraphQLActive) {
    plansData = gqlPlanData.get('plans', List()) || List()
  }

  const eventsPlanData = plansData && plansData.find((e) => e.get('sku') === PLAN_SKU_INCREASED_PRICE_GAIA_PLUS)
  const priceString = (eventsPlanData && new Intl.NumberFormat(
    language,
    {
      style: 'currency',
      currency: eventsPlanData.get('currencyIso'),
      minimumFractionDigits: 0,
    },
  ).format(eventsPlanData.get('costs').first())) || ''

  const billingPeriodAbbreviation = (eventsPlanData && eventsPlanData.get('billingPeriodAbbreviation')) || ''
  // this is set up to use the old "image-render" path, instead of the new "assets-render"
  // because of this, there can't be any image optimizations
  const imageUrl = 'https://brooklyn.gaia.com/v1/assets-render/307f916a-e77b-47fa-8fdf-b3b28024452a'
  const eventsPlusText = staticText.getIn(['data', 'eventsPlus'])
  const eventsPlusBtnText = staticText.getIn(['data', 'upgradeNow'])
  const topSectionTitleDescription = staticText.getIn(['data', 'topSectionTitleDescription'])
  const descriptionFirstPhrase = topSectionTitleDescription.get('firstPhrase')

  return (
    <div className="events-page__jumbotron-container">
      <HeroImage
        className={['background-hero']}
        hasOverlay={false}
        smallUrl={imageUrl}
        mediumSmallUrl={imageUrl}
        mediumUrl={imageUrl}
        largeUrl={imageUrl}
        url={imageUrl}
        optimizeImage={false}
      />
      <div className="sections-container">
        <div className="left-section">
          <div className="text-container">
            <H1 as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]} className="title">{eventsPlusText}</H1>
            <div className="description">{descriptionFirstPhrase}</div>
          </div>
        </div>
        {
          planGraphQLActive && !priceString && !isAiOnly
            ? <div className="right-section">
                <div className="box-container">
                  <div className="events-page__plan-placeholder" />
                  <div className="events-page__plan-placeholder" />
                  <div className="events-page__plan-placeholder" />
                </div>
              </div>
            : null
        }
        {
          priceString && !isAiOnly
            ? <div className="right-section">
              <div className="box-container">
                <H3 as={[HEADING_TYPES.H2_MOBILE, HEADING_TYPES.H3_DESKTOP]} className="events" >{eventsPlusText}</H3>
                <H2 as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]}>{priceString}<span className="yr">/{billingPeriodAbbreviation}</span></H2>
                  {
                    getAuthIsLoggedIn(auth) && !userShouldReactivate(props)
                      ? <Button
                          type={TYPES.PRIMARY}
                          onClick={() => {
                            if (isAccountOwner) {
                              return userPlanComplete && gqlPlanData.get('complete') && onClickAccountChangePlan(PLAN_SKU_INCREASED_PRICE_GAIA_PLUS, props, plansData, currentPlan)
                            }

                            if (!isAccountOwner) {
                              onClickChildProfileChangePlan(props)
                            }

                            return null
                          }}
                          disabled={!isAccountOwner && !userPlanComplete && !gqlPlanData.get('complete')}
                        >
                          {eventsPlusBtnText}
                        </Button>
                      : <Button
                          type={TYPES.PRIMARY}
                          url={`${URL_GO_PAGE}?sku=${PLAN_SKU_INCREASED_PRICE_GAIA_PLUS}`}
                        >
                          {userShouldReactivate(props) ? staticText.getIn(['data', 'subscribe']) : staticText.getIn(['data', 'signUp'])}
                        </Button>
                  }
                </div>
              </div>
            : null
        }
      </div>
    </div>
  )
}

class EventsPage extends Component {
  constructor (props) {
    super(props)
    const { language } = props
    props.getLiveAccessEventList(language)
  }

  componentDidMount () {
    const { props } = this
    const {
      auth,
      path,
      setPageSeo,
    } = props
    const footer = document && document.getElementById('footer-app')
    if (footer) {
      footer.classList.add('live-events__events-detail-page__footer-extra-space')
    }
    const seo = getSeo({
      pathname: path,
      loggedIn: Boolean(auth.get('jwt')),
    })
    setPageSeo({
      title: seo.title,
      description: seo.description,
      noFollow: seo.noFollow,
      noIndex: seo.noIndex,
      ogDescription: seo.ogDescription,
      ogTitle: seo.ogTitle,
      ogImage: seo.ogImage,
      twitterCard: seo.twitterCard,
      twitterImage: seo.twitterImage,
      twitterTitle: seo.twitterTitle,
      twitterDescription: seo.twitterDescription,
      location: path,
    })
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const { language } = props
    const { language: prevLanguage } = prevProps

    if (prevLanguage !== language) {
      props.getLiveAccessEventList(language)
    }
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount () {
    const footer = document && document.getElementById('footer-app')
    if (footer) {
      footer.classList.remove('live-events__events-detail-page__footer-extra-space')
    }
  }

  getGridWithBackgroundData = (sectionData) => {
    const { videos: allVideos, language } = this.props
    const title = sectionData.getIn(['header', 'label'])
    const description = sectionData.getIn(['footer', 'label'])
    const videosIds = sectionData.getIn(['tabs', '0', 'tabContent']).map((tabContent) => tabContent.get('contentId'))
    let gridData = videosIds.map((videoId) => allVideos.getIn([getSafeNodeId(videoId), language, 'data']))

    const hasNilValue = gridData.some((item) => _isNil(item))
    if (hasNilValue) {
      gridData = null
    }
    return [title, description, gridData]
  }

  sectionManager = (displayMode, sectionId) => {
    switch (displayMode) {
      case DISPLAY_MODES.FAQ:
        return this.renderFaqs(sectionId)
      case DISPLAY_MODES.GRID_WITH_BACKGROUND:
        return this.renderGridWithBrackground(sectionId)
      case DISPLAY_MODES.TILE_LIST_5X7:
        return this.renderTileList5x7(sectionId)
      default:
        return null
    }
  }

  renderEventsPlusSection = (displayMode) => {
    const { props } = this
    const { sectionIds, pmSection } = props

    if (sectionIds.isEmpty()) {
      return null
    }
    const readySectionIds = sectionIds.filter((sectionId) => {
      const sectionDisplayMode = getPmSectionDisplayMode({ pmSection, sectionId })
      return sectionDisplayMode === displayMode
    })

    if (_isNil(readySectionIds.getIn(['0'])) && readySectionIds.size < 1) {
      return null
    }
    return (readySectionIds.getIn(['0']) && readySectionIds.size > 0)
     && this.sectionManager(displayMode, readySectionIds.getIn(['0']))
  }

  renderGridWithBrackground = (sectionId) => {
    const { props } = this
    const { pmSection, auth, location } = props
    const section = pmSection.get(sectionId)
    const sectionData = section.getIn(['data', 'data'])
    const [title, description, gridData] = this.getGridWithBackgroundData(sectionData)

    if (_isNil(sectionId)
     || _isNil(gridData)
     || _isNil(section)
     || _isNil(sectionData)
     || gridData.size < 1) {
      return null
    }

    return (
       <React.Fragment>
         <GridWithBackground
           title={title}
           description={description}
           gridData={gridData}
           auth={auth}
           location={location}
           seeAllUrl={URL_ARCHIVED_WORKSHOPS}
         />
       </React.Fragment>
    )
  }

  renderTileList5x7 = (sectionId) => {
    const { props } = this
    const { pmSection, location, staticText } = props
    const section = pmSection.get(sectionId)
    const sectionData = section.getIn(['data', 'data'])
    const title = sectionData.getIn(['header', 'label'])
    const description = sectionData.getIn(['footer', 'label'])

    if (_isNil(sectionId)) {
      return null
    }

    return (
      <div className="events-page__watch-first-episode">
        <div className="events-page__watch-first-episode__header">
          <div className="events-page__watch-first-episode__header__top-container">
            {title && <H2 as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]} >{title}</H2>}
            <div className="events-page__watch-first-episode__header__top-container__button">
              <Button
                url={URL_ARCHIVED_WORKSHOPS}
                className="account-pause-confirm__cta"
                type={TYPES.GHOST}
              >
                {staticText.getIn(['data', 'seeAllButtonText'])}
                <IconV2
                  className="account-pause-confirm__icon"
                  type={ICON_TYPES.CHEVRON_RIGHT}
                />
              </Button>
            </div>
          </div>
          {description && <p className="grid-with-background__header__description">{description}</p>}
        </div>
        <div className="events-page__watch-first-episode__content-list">
          <SectionTilesList
            sectionId={sectionId}
            sectionIndex={0}
            rowPlacement={1}
            uiLocation="Gaia+ About"
            location={location}
            displayMode={TILE_VERTICAL}
            screenType={SCREEN_TYPE_EVENTS_PLUS}
            sectionType={TYPE_CONTENT_LIST}
          />
        </div>
      </div>
    )
  }

  renderFaqs = (sectionId) => {
    const { props } = this
    const { pmSection, language } = props
    const section = pmSection.get(sectionId)
    const sectionData = section.getIn(['data', 'data'], Map()) || Map()
    const titleGroupIds = (sectionData.getIn(['tabs', '0', 'tabContent'], List()) || List())
      .map((item) => createTitleGroupId(item.get('contentId'), item.get('contentType'))) || List()

    return (
      <div className="events-page__events-faqs-container">
        <FaqsList
          pmSection={pmSection}
          language={language}
          sectionId={sectionId}
          titleGroupIds={titleGroupIds.toJS()}
        />
      </div>
    )
  }

  renderEventList = (isEventsPlusMember = true) => {
    const { props } = this
    const {
      user, language, staticText, eventsList,
    } = props
    if (!eventsList) { return null }
    const email = user.getIn(['data', 'mail'])
    return (
      <EventList
        eventsList={eventsList}
        language={language}
        staticText={staticText}
        email={email}
        isEventsPlusMember={isEventsPlusMember}
      />
    )
  }

  renderExperience = () => {
    const { props } = this
    const { staticText, auth } = props
    const subscriptions = auth.getIn(['subscriptions'])
    const isEntitled = subscriptions && subscriptions.size
    const buttonText = isEntitled ? staticText.getIn(['data', 'upgradeNow']) : staticText.getIn(['data', 'joinNow'])
    const buttonURL = isEntitled ? UPGRADE_NOW_URL : JOIN_NOW_URL
    const buttonQuery = isEntitled ? null : JOIN_NOW_QUERY
    return (
      <div>
        <Experience
          title={staticText.getIn(['data', 'eventExperienceTitle'])}
          cost={`$299.00 ${staticText.getIn(['data', 'perYear'])}`}
          description={staticText.getIn(['data', 'eventExperienceDescription'])}
          buttonText={buttonText}
          url={buttonURL}
          query={buttonQuery}
          backgroundColor="rgba(0, 0, 0,0.25)"
        />
        <div className="fixed-footer">
          <Button
            type={TYPES.PRIMARY}
            url={buttonURL}
            query={buttonQuery}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    )
  }

  renderDebugInfo = () => {
    const { props } = this
    const { isLiveAccessMember } = props
    const username = props.auth.get('username')
    return (
      <pre>
        {!username && <div>I am anonymous user</div>}
        {username && <div>I am {username} with subscriptions: {props.auth.get('subscriptions').toJS().join(':')}</div>}
        I am {!isLiveAccessMember && <span>not</span>} an Gaia+ member
      </pre>
    )
  }

  renderTopSectionValues = () => {
    const { props } = this
    const { staticText, language } = props
    const descriptionText = staticText.getIn(['data', 'eventsPlusValuesDescription'])
    let values = staticText.getIn(['data', 'eventsPlusValuesList'])
    const isEnglish = language === EN
    const icons = [
      ICON_TYPES.METAPHYSICS_2,
      ICON_TYPES.FRIENDS_2,
      ICON_TYPES.MEDICINE_2,
      isEnglish ? ICON_TYPES.LIGHTHOUSE : ICON_TYPES.THIRD_EYE,
    ]

    values = isEnglish
      ? values.filter((_, index) => index !== icons.length - 1)
      : values.filter((_, index) => index !== icons.length)

    return (
      <React.Fragment>
        <div className="events-page__main-description-container">
          <p className="events-page__main-description">{descriptionText}</p>
        </div>
        <div className="events-page__values-list">
          {
            values.map((value, index) => (

                <div className="item-wraper" key={value.get('title')}>
                  <IconV2 className="icon" type={icons[index]} style={ICON_STYLES.BANNER} />
                  <div className="item">
                    <H4>{value.get('title', '')}</H4>
                    <p className="description">{value.get('description')}</p>
                  </div>
                </div>
            ))
          }
        </div>
      </React.Fragment>
    )
  }

  renderVideoSection = () => {
    const { props } = this
    const { staticText } = props
    return (
      <div className="events-page__video-section">
        <H2 as={[HEADING_TYPES.H1_MOBILE, HEADING_TYPES.H2_DESKTOP]} className="events-page__video-section__title">{staticText.getIn(['data', 'eventsPlusVideoSectionTitle'])}</H2>
        <DropInVideoPlayer
          autoplay
          mediaId={205153}
          playsinline
          controls={{
            type: 'basic',
            visibleControls: [BASIC_CONTROL_OPTIONS_VOLUME, BASIC_CONTROL_OPTIONS_VOLUME_LABEL],
          }}
        />
      </div>)
  }

  renderTopSectionListEvents = () => {
    const isEventsPlusMember = false
    return (
      <div className="events-page__events-list-container">
        {
          this.renderEventList(isEventsPlusMember)
        }
      </div>
    )
  }

  renderTopSection = () => {
    return (
      <React.Fragment>
        <TopSectionBanner {...this.props} />
        {this.renderTopSectionValues()}
      </React.Fragment>
    )
  }

  // TODO(alexismundu): Move this view to a single component
  renderNonEventsPlusMembersView = () => {
    return (
      <React.Fragment>
        {this.renderTopSection()}
        {this.renderEventsPlusSection(DISPLAY_MODES.TILE_LIST_5X7)}
        {this.renderTopSectionListEvents()}
        {this.renderVideoSection()}
        {this.renderEventsPlusSection(DISPLAY_MODES.FAQ)}
      </React.Fragment>
    )
  }

  renderEventsPlusDefault = () => {
    const { props } = this
    const {
      eventsList, debug, language, staticText, isLiveAccessMember,
    } = props
    if (!eventsList) { return null }
    const videoId = bannerMediaIdByLanguage[language]
    const mediaId = 205000
    const { features: { eventsPlusVideoAndCopy } } = config
    return (<React.Fragment>
      {
        debug ? this.renderDebugInfo() : null
      }
      {
        !!eventsPlusVideoAndCopy
        && <React.Fragment>
          <div className="events-page__banner">
            <DropInVideoPlayer
              autoplay
              loop
              playsinline
              controls={{
                type: BASIC_CONTROLS,
                visibleControls: [BASIC_CONTROL_OPTIONS_VOLUME],
              }}
              mediaId={Number(mediaId)}
              playerSrc={createPlayerSrc(1263232739001, videoId)}
            />
          </div>
          <div className="events-page__about-events">
            <div className="events-page__about-events__text">
              {componentFromHTML(staticText.getIn(['data', 'aboutEvents']))}
            </div>
          </div>
        </React.Fragment>
      }
      {this.renderEventList()}
      <div id="LAM">
        { !isLiveAccessMember && this.renderExperience()}
      </div>
    </React.Fragment>)
  }

  render () {
    const { props } = this
    const { isLiveAccessMember, auth } = props
    const subscriptions = auth.getIn(['subscriptions'])
    const isEntitled = subscriptions && subscriptions.size
    const isEventsPlusMember = isEntitled && isLiveAccessMember
    return (
      <div className="events-page">
        {
          config.features.eventsPlus.v2 && !isEventsPlusMember
            ? this.renderNonEventsPlusMembersView()
            : this.renderEventsPlusDefault()
        }
      </div>
    )
  }
}

export default compose(
  connectRedux(
    (state) => {
      const {
        pmScreen = Map(), pmSection = Map(),
      } = state
      const language = state.user.getIn(['data', 'language', 0], 'en')
      const sectionIds = getPmScreenSectionSectionIds({
        pmScreen, screenType: SCREEN_TYPE_EVENTS_PLUS, language,
      }) || List()

      return {
        auth: state.auth,
        app: state.app,
        user: state.user,
        plans: state.plans,
        debug: state.resolver.getIn(['query', 'debug']) === 'true',
        isLiveAccessMember: !!state.auth.get('subscriptions') && state.auth.get('subscriptions').includes(LIVE_ACCESS_SUBSCRIPTION_CODE),
        liveAccessEvents: state.liveAccessEvents,
        eventsList: state.liveAccessEvents.getIn(['eventsList',
          language,
          'data', 'events']),
        language,
        query: state.resolver.get('query'),
        path: state.resolver.get('path'),
        pmSection,
        sectionIds,
        userAccount: state.userAccount,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setPageSeo: actions.page.setPageSeo,
        getLiveAccessEventList: actions.liveAccessEvents.getLiveAccessEventList,
        setPlanChangeSelected: actions.plans.setPlanChangeSelected,
        dismissModal: actions.dialog.dismissModal,
        renderModal: actions.dialog.renderModal,
      }
    },
  ),
  connectStaticText({ storeKey: 'eventsPage' }),
)(EventsPage)
